import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, NgZone, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IHeadlessPaymentMethodButton } from '@primer-io/checkout-web';
import { PrimerPaymentMethodType } from '../primer.model';
import { WaitingService } from 'libs/orderform-widgets/src/lib/services/waiting.service';

@Component({
  selector: 'orderform-primer-confirm-modal',
  templateUrl: './primer-confirm-modal.component.html',
  styleUrls: ['./primer-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrimerConfirmModalComponent implements OnInit {
  @Input() paymentMethodType: PrimerPaymentMethodType = PrimerPaymentMethodType.NONE;
  @Input() buttonId: string;
  @Input() dialogRef: MatDialogRef<any>;
  @Input() paymentButton: IHeadlessPaymentMethodButton;
  processingOrder = signal<boolean>(false);

  @Output() readonly closed = new EventEmitter<void>();
  @Output() readonly opened = new EventEmitter<void>();
  @Output() readonly buttonRendered = new EventEmitter<void>();

  constructor(private waitingService: WaitingService, private ngZone: NgZone) {}

  ngOnInit(): void {
    if (!this.dialogRef) return;

    this.dialogRef.afterOpened().subscribe(() => {
      this.opened.emit();

      if (this.paymentButton) {
        // Render without unsupported options (Primer headless docs)
        this.paymentButton.render(this.buttonId, {
          style: {
            buttonType: 'short',
          },
        });
        this.buttonRendered.emit();
      }
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.waitingService.hide();
    });
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.closed.emit();
    }
  }

  setProcessingOrder(isProcessing: boolean): void {
    this.processingOrder.set(isProcessing);
  }
}
